import React from "react";
import {getBaseURL} from "components/helpers/HostURLHelper.jsx";
import ErrorBoundary from "components/ErrorBoundary.js";
import GridContainer from "Grid/GridContainer.jsx";
import GridItem from "Grid/GridItem.jsx";
import InputLabel from '@material-ui/core/InputLabel';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import InteractiveList from 'components/misc/InteractiveList';
import ErrorLogo from "@material-ui/icons/Error";
import MarksAndRanksList from "components/analysis/tables/MarksAndRanksList"
import QuestionsErrorSummary from "components/analysis/tables/QuestionsErrorSummary"
import UnattemptedStudentsList from "components/analysis/tables/UnattemptedStudentsList"
import qs from 'query-string';
import Button from "CustomButtons/Button.jsx";
import {formatDate} from "components/helpers/DateTimeHelper.jsx";
import $ from 'jquery';

const getMuiThemeForTable =  createMuiTheme({
    overrides: {
      MuiPaper: {
        elevation4: {
          boxShadow: "none"
        }
      },
      MUIDataTableToolbarSelect:{
        title:{
          display: "none"
        },
        root:{
          backgroundColor: "none",
          boxShadow: "none",
          justifyContent: "normal"
        }
      },
      MUIDataTableHeadCell: {
        fixedHeader:{
          zIndex: "none"
        }
      },
    typography: {
      useNextVariants: true,
    },
    },
    typography: {
      useNextVariants: true,
    }
  })


class TestAnalysisDashboard extends React.Component {

  state = {
    errorMessages: [],
    testResults:[],
    scheduledTestId: "",
    scheduledTestPaperId: "",
    fullResultsData: "",
    selectedReport: 0,
    scheduledTestData: "",
    viewport: "",
    unattemptedStudents: [],
    downloadingFullReport: false
  }

  componentDidMount(){
      const scheduled_test_id = qs.parse(this.props.location.search).scheduled_test_id; 
      const scheduled_test_paper_id = qs.parse(this.props.location.search).scheduled_test_paper_id;
      const viewport = qs.parse(this.props.location.search).viewport; 
      if (viewport && viewport == "embedded"){
        this.setState({viewport})
      } 
    if(scheduled_test_paper_id){ //Process of duplicate only if test_id exists
       $.ajax({
          type: 'GET',
          url: getBaseURL() + '/react/test-paper-analysis.json?scheduled_test_paper_id=' + scheduled_test_paper_id,
        }).done((data, status, jqXHR)=>{
          this.setState({scheduledTestData: data["scheduled_test_info"],
            fullResultsData: data,
            scheduledTestPaperId: scheduled_test_paper_id});

	   this.fetchUnattemptedStudents(scheduled_test_paper_id);
        
        }).fail((jqXHR, textStatus, errorThrown) => {
            var errorMessages = this.state.errorMessages;
            errorMessages.push({message: jqXHR["responseJSON"].message})
            this.setState({errorMessages: jqXHR["responseJSON"].message});
        })	
    }else if(scheduled_test_id){
      $.ajax({
          type: 'GET',
          url: getBaseURL() + '/react/total-test-analysis.json?scheduled_test_id=' + scheduled_test_id,
        }).done((data, status, jqXHR)=>{
          this.setState({scheduledTestData: data["scheduled_test_info"],
            fullResultsData: data,
            scheduledTestId: scheduled_test_id});
        
        }).fail((jqXHR, textStatus, errorThrown) => {
            var errorMessages = this.state.errorMessages;
            errorMessages.push({message: jqXHR["responseJSON"].message})
            this.setState({errorMessages: jqXHR["responseJSON"].message});
        })

    }
  }

  selectedReportChanged = (e) => {
    e.preventDefault();
    const newSelectedReport = parseInt(e.currentTarget.id);
    this.setState({selectedReport: newSelectedReport});
  }


  goToUserTestAnalysis = (e) => {
    e.preventDefault();
    var user_id = e.currentTarget.name;
    var scheduledTestData = this.state.scheduledTestData;
    var scheduledTestPaperId = this.state.scheduledTestPaperId;
    if(user_id && scheduledTestData["scheduled_test_id"]){
      if(scheduledTestPaperId){
        this.props.history.push('/student-test-dashboard?user_id='+user_id+'&test_id='+scheduledTestData["scheduled_test_id"]+'&test_paper_id='+scheduledTestPaperId);
      }else{
        this.props.history.push('/student-test-dashboard?user_id='+user_id+'&test_id='+scheduledTestData["scheduled_test_id"]);
      }
    } else{
      var errorMessages = this.state.errorMessages;
      this.setState({errorMessages: errorMessages});
    }
  }

  handleDoneAction = (e) => {
    e.preventDefault();
    if(this.state.viewport == "embedded"){
      this.props.history.goBack()
    }else{
      this.props.history.push('/schedule-tests');
    }
  }

 fetchUnattemptedStudents = (scheduledTestPaperId) => {
  if(!scheduledTestPaperId){
    return;
  }

  $.ajax({
    type: 'GET',
    url: getBaseURL() + '/get-unattempted-students?scheduled_test_paper_id=' + scheduledTestPaperId,
  }).done((data, status, jqXHR)=>{
    this.setState({
      unattemptedStudents: data["results"] || []
    });
  }).fail((jqXHR, textStatus, errorThrown) => {
    var errorMessages = this.state.errorMessages || [];
    errorMessages.push({message: "Unable to fetch unattempted students for full report"});
    this.setState({errorMessages});
  })
}

csvValue = (value) => {
  if(value === null || value === undefined){
    return "";
  }

  var stringValue = value.toString();
  if(stringValue.indexOf('"') >= 0){
    stringValue = stringValue.replace(/"/g, '""');
  }

  if(
    stringValue.indexOf(",") >= 0 ||
    stringValue.indexOf("\n") >= 0 ||
    stringValue.indexOf('"') >= 0
  ){
    return '"' + stringValue + '"';
  }

  return stringValue;
}

downloadCsv = (filename, columns, rows) => {
  var csvRows = [];

  csvRows.push(columns.map(this.csvValue).join(","));

  for(var i = 0; i < rows.length; i++){
    csvRows.push(rows[i].map(this.csvValue).join(","));
  }

  var csvContent = csvRows.join("\n");
  var blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  var link = document.createElement("a");

  if(link.download !== undefined){
    var url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

buildFullReportCsvData = () => {
  var fullResultsData = this.state.fullResultsData;
  var unattemptedStudents = this.state.unattemptedStudents || [];
  var results = fullResultsData && fullResultsData["results"] ? fullResultsData["results"] : [];

  if(!results || results.length < 1){
    return {
      columns: [],
      rows: []
    };
  }

  var subjectString = results[0]["sub_names"];
  var subjectsShortNames = results[0]["sub_short_names"];

  if(!subjectString){
    return {
      columns: [],
      rows: []
    };
  }

  var subjectsArray = subjectString.split(",");
  var subjectsShortNameArray = subjectsShortNames ? subjectsShortNames.split(",") : subjectsArray;

  var columns = [
    "Username",
    "Name",
    "Campus",
    "Section"
  ];

  for(var i = 0; i < subjectsArray.length; i++){
    var subjectName = subjectsArray[i];
    var subjectShortName = subjectsShortNameArray[i] || subjectName;

    columns.push(subjectName + " Marks");
    columns.push(subjectName + " Rank");
    columns.push(subjectShortName + " Correct");
    columns.push(subjectShortName + " Incorrect");
    columns.push(subjectShortName + " Unattempted");
  }

  columns.push("Total Marks");
  columns.push("Total Rank");
  columns.push("Attempt Status");

  var rows = [];

  for(var j = 0; j < results.length; j++){
    var resultRow = results[j];
    var row = [];

    row.push(resultRow["user_login_id"]);
    row.push(resultRow["user_name"]);
    row.push(resultRow["branch_name"]);
    row.push(resultRow["section_name"]);

    for(var k = 0; k < subjectsArray.length; k++){
      var subject = subjectsArray[k];
      var subjectInfo = resultRow["subjects_info"] && resultRow["subjects_info"][subject]
        ? resultRow["subjects_info"][subject]
        : {};

      row.push(subjectInfo["marks"]);
      row.push(subjectInfo["rank"]);
      row.push(subjectInfo["correct"]);
      row.push(subjectInfo["incorrect"]);
      row.push(subjectInfo["unattempts"]);
    }

    row.push(resultRow["total_marks"]);
    row.push(resultRow["rank"]);
    row.push("Attempted");

    rows.push(row);
  }

  for(var l = 0; l < unattemptedStudents.length; l++){
    var unattemptedRow = unattemptedStudents[l];
    var row = [];

    row.push(unattemptedRow["username"]);
    row.push(unattemptedRow["fullname"]);
    row.push(unattemptedRow["branch_name"]);
    row.push(unattemptedRow["section_name"]);

    for(var m = 0; m < subjectsArray.length; m++){
      row.push("NA"); // Subject Marks
      row.push("NA"); // Subject Rank
      row.push("NA"); // Correct
      row.push("NA"); // Incorrect
      row.push("NA"); // Unattempted
    }

    row.push("NA"); // Total Marks
    row.push("NA"); // Total Rank
    row.push("Unattempted");

    rows.push(row);
  }

  return {
    columns: columns,
    rows: rows
  };
}

handleFullReportDownload = (e) => {
  e.preventDefault();

  var reportData = this.buildFullReportCsvData();

  if(!reportData.columns || reportData.columns.length < 1){
    var errorMessages = this.state.errorMessages || [];
    errorMessages.push({message: "Full report data is not available for download"});
    this.setState({errorMessages});
    return;
  }

  var reportName = this.state.scheduledTestData && this.state.scheduledTestData["scheduled_test_name"]
    ? this.state.scheduledTestData["scheduled_test_name"]
    : "TestAnalysis";

  var filename = reportName + "_FullStudentReport_" + (new Date().toISOString().substring(0,16)) + ".csv";

  this.downloadCsv(filename, reportData.columns, reportData.rows);
}

  render () {
    const{classes} = this.props;
    const{scheduledTestData,scheduledTestId, scheduledTestPaperId,fullResultsData,selectedReport} = this.state;
    const titleStyle={
      color: "rgb(34, 56, 69)",
      fontWeight: "600",
      fontSize: "20px",
      paddingLeft: "20px",
    };
    const subtitleStyle={
      color: "rgb(34, 56, 69)",
      fontWeight: "600",
      fontSize: "18px",
      fontFamily: "open sans, Helvetica Neue, Helvetica, Arial, sans-serif",
      paddingBottom: "10px"
    };    
    const buttonStyle = {
    paddingTop: "8px",
    paddingBottom: "8px",
    paddingLeft: "20px",
    paddingRight: "20px",
    textTransform: "capitalize",
    background: "#3f51b5",
      lineHeight: "20px",
      borderRadius: "3px",
      marginBottom: "auto"
  };
    return (
      <React.Fragment>
        <ErrorBoundary>
          <GridContainer style={{
          backgroundColor: "white",
          paddingTop: "0px",
          paddingBottom: "20px",
          width: "100%", 
          margin: "10px 0px 0px",
          marginTop: "0px"}}
          spacing={24}>
          <GridItem xs={12} sm={12} md={8} style={{paddingTop: "0px", paddingBottom: "0px"}}>
  <h1 style={titleStyle} >Test Analysis Dashboard</h1>
</GridItem>

<GridItem xs={12} sm={12} md={4} style={{paddingTop: "0px", paddingBottom: "0px", margin: "auto", textAlign: "right"}}>
  {(scheduledTestPaperId || scheduledTestId) && fullResultsData &&
    <Button 
      style={{...buttonStyle, marginRight: "8px"}}
      onClick={this.handleFullReportDownload}>
      Download Full Report
    </Button>
  }
  <Button 
    style={buttonStyle}
    onClick={this.handleDoneAction}>Done
  </Button> 
</GridItem>
          <GridItem xs={12} sm={12} md={12} style={{paddingTop: "0px", paddingBottom: "0px"}}>
            <hr style={{marginTop: "10px", marginBottom: "10px"}}/>
          </GridItem>
        {this.state.errorMessages && this.state.errorMessages.length > 0 &&
        <React.Fragment>
          <GridItem  xs={12} sm={12} md={2} style={{paddingTop: "0px", paddingBottom: "0px"}}>
            </GridItem>
          <GridItem xs={12} sm={12} md={10} style={{paddingTop: "0px", paddingBottom: "0px"}}>
          {this.state.errorMessages && this.state.errorMessages.length > 0 ? this.state.errorMessages.map((errorMessage, index) => 
                  <div key={index}>
                  <ErrorLogo style={{verticalAlign: "middle", marginRight: "5px", color: "#f44336"}}></ErrorLogo>
                  <p style={{display: "inline-block", color:"#f44336", fontSize: "0.8rem", overflow: "inherit"}} /*TODO className={classes.robotoFontRegular}*/>{errorMessage["message"]}</p> 
                  </div>
                  ): null
                }
              </GridItem>
          </React.Fragment>
          }
          <React.Fragment>
              <GridItem  xs={12} sm={12} md={1}  style={{padding: "0px 12px"}}>
              </GridItem>
              <GridItem  xs={12} sm={12} md={11}  style={{padding: "0px 12px"}}>
                <h3 style={subtitleStyle} >Test Summary</h3>
              </GridItem>
              <GridItem  xs={12} sm={12} md={2} style={{padding: '12px'}} >
              </GridItem>
              <GridItem  xs={12} sm={12} md={3} style={{padding: '12px'}}>
              <InputLabel shrink htmlFor="material">
                    Schedule Test Name
                </InputLabel>
                <p style={{fontSize: "16px", color: "rgb(34, 56, 69)"}} >{scheduledTestData["scheduled_test_name"]}</p>
                <InputLabel shrink htmlFor="material">
                    Schedule Test Number
                </InputLabel>
                <p style={{fontSize: "16px", color: "rgb(34, 56, 69)"}} >{scheduledTestData["scheduled_test_identifier"]}</p>
              </GridItem>
              <GridItem  xs={12} sm={12} md={3} style={{padding: '12px'}}>
                <InputLabel shrink htmlFor="material">
                    User Group
                </InputLabel>
                <p style={{fontSize: "16px", color: "rgb(34, 56, 69)"}} >{scheduledTestData["user_group_indentifier"]}</p>
                <InputLabel shrink htmlFor="material">
                    Scheduled At
                </InputLabel>
                <p style={{fontSize: "16px", color: "rgb(34, 56, 69)"}} >{formatDate(scheduledTestData["schedule_start_time"])}</p>
              </GridItem>
              <GridItem  xs={12} sm={12} md={3} style={{padding: '12px'}}>
                <InputLabel shrink htmlFor="material">
                    Test Program
                </InputLabel>
                <p style={{fontSize: "16px", color: "rgb(34, 56, 69)"}} >{scheduledTestData["program_short_name"]}</p>
                <InputLabel shrink htmlFor="material">
                    Test Type
                </InputLabel>
                <p style={{fontSize: "16px", color: "rgb(34, 56, 69)"}} >{scheduledTestData["test_type_short_name"]}</p>
              </GridItem>
              <GridItem  xs={12} sm={12} md={12} style={{padding: '12px 24px'}}>
              <InteractiveList selectedListIndex={selectedReport} onSelectedListChange={this.selectedReportChanged}/>
              </GridItem>
              {(scheduledTestPaperId || scheduledTestId)&& fullResultsData &&  selectedReport == 0 &&
                <GridItem  xs={12} sm={12} md={12} style={{padding: '12px 24px'}}>
                  <MarksAndRanksList reportName={scheduledTestData["scheduled_test_name"]} goToUserTestAnalysis={this.goToUserTestAnalysis} data={fullResultsData} paperId={scheduledTestPaperId}/>
                </GridItem>
              }
              {(scheduledTestPaperId || scheduledTestId) && fullResultsData && selectedReport == 1 &&
                <GridItem  xs={12} sm={12} md={12} style={{padding: '12px 24px'}}>
                  <QuestionsErrorSummary reportName={scheduledTestData["scheduled_test_name"]} goToUserTestAnalysis={this.goToUserTestAnalysis} data={fullResultsData} paperId={scheduledTestPaperId}/>
                </GridItem>
              }
              {scheduledTestPaperId && selectedReport == 2 &&
                <GridItem  xs={12} sm={12} md={12} style={{padding: '12px 24px'}}>
                <UnattemptedStudentsList reportName={scheduledTestData["scheduled_test_name"]} paperId={scheduledTestPaperId}/>
                </GridItem>
              }
              { (!scheduledTestPaperId) && scheduledTestId && selectedReport == 2 &&
                <p style={{margin: "auto", marginTop: "20px" ,width:"fit-content", fontWeight: "500",fontSize: "16px", color: "rgb(34, 56, 69)"}} >Report only available for Test Paper</p>
              }
            </React.Fragment>
            </GridContainer>
        </ErrorBoundary>
      </React.Fragment>
    );
  }
}

export default TestAnalysisDashboard;
